module.exports = __webpack_public_path__ + "static/media/teaser2-droetker-x2.fd8f1826.jpg";